import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { DECLINE_REFERRAL_QUERY_KEY, PATIENT_PROFILE_QUERY_KEY } from '../constants';
import { declineReferral } from '../services';
import { DeclineReferralProps } from '../types';

function useMutationDeclineReferral(
  onSuccess: () => void,
  onError?: (err: any) => any,
): UseMutationResult<string, unknown> {
  const queryClient = useQueryClient();

  const mutationFn = async (props: DeclineReferralProps): Promise<any> => {
    return await declineReferral(props);
  };

  const onMutateFn = async (): Promise<any> => {};

  const onErrorFn = (err: unknown): void => {
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {};

  const onSuccessFn = async (): Promise<void> => {
    void queryClient.invalidateQueries([PATIENT_PROFILE_QUERY_KEY]);
    onSuccess?.();
  };

  return useMutation<string, unknown, any, any>([DECLINE_REFERRAL_QUERY_KEY], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess: onSuccessFn,
  });
}

export default useMutationDeclineReferral;
